import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import backend from 'i18next-http-backend'; //takes files from public/locales/{language}/translation.json

const getBasePath = () => {
  if (process.env.NODE_ENV === 'development') {
    return '';
  }
  const pathname = window.location.pathname;
  const prRegex = /^(\/PR\d+)/;
  const prMatch = prRegex.exec(pathname);
  if (prMatch) {
    return prMatch[1];
  }
  return '';
};

const basePath = getBasePath();

i18next
  .use(backend)
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `${basePath}/locales/{{lng}}/translation.json`
    },
    fallbackLng: 'en',
    // Map language codes to available translations
    load: 'languageOnly',
    // set true for debug mode. Should be false for prod
    debug: false,
    interpolation: {
      escapeValue: false,
      keySeparator: '.'
    }
  });

export default i18next;
